// scr/Pages/ChooseGift.js

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Check, ChevronDown, Minus, Plus } from "lucide-react";
import "./ChooseGift.css";
import Frequency from "../Components/Frequency";
import SmoothPriceDisplay from "../Components/SmoothPriceDisplay";
import Product from "../Components/Product"
import { ob } from "../utils";
import InjectStyles from "./InjectStyles.js";

export const ChooseGift = () => {
  console.log("ChooseGift component mounted");
  const productAsItAs = JSON.parse(JSON.stringify(window.chargezenProduct));
  const locales = window?.chargezenLocale;
  const urlParams = window.chargezenUrlParams;



  const specialDiscountRules = {
    frank20: { percentage: 21.49, variantId: '48102838010098' },
    frank33: { percentage: 15, variantId: '48102837977330' },
    
  };


  const variantIdToUtmMap = {
    '48102838010098': 'frank20',
    '48102837977330': 'frank33',
  };



  const currentDiscountRule = specialDiscountRules[urlParams?.utm_source];
  const isFrankPromotion = urlParams?.utm_source === 'frank20' || urlParams?.utm_source === 'frank33' || urlParams?.variant === '48102838010098' || urlParams?.variant === '48102837977330';


  const currencySymbol = locales?.subscriptionLocale?.currency || "$";
  const { paymentType } = useParams();
  const preferences = window?.chargezenPreferences || {};
  //const [abTestVariant] = useState(() => window.abTestVariant);
  /*const [abTestVariant] = useState(() => {
    const variant = Math.random() < 0.5 ? 'A' : 'B';
   // const variant = Date.now() % 2 === 0 ? 'A' : 'B';
    console.log('Generated variant:', variant);
    return variant;
  });*/

  const priceElementRefs = useRef([]);

    const currentProductId = productAsItAs.id?.toString();
    const ke4ProductId = '4901145608328'; // e.g., '1234567890'

  const [abTestVariant] = useState(() => {
    // Replace 'YOUR_PRODUCT_ID' with the specific product ID you want to test
    const productIdForTest = '529912915574';
    const currentProductId = productAsItAs.id?.toString();
    const ke4ProductId = '4901145608328'; // e.g., '1234567890'


    // Only run A/B test for specific product ID
    if (currentProductId === productIdForTest) {
      const variant = Math.random() < 0.5 ? 'A' : 'B';
      console.log('Generated variant for test product:', variant);
      return variant;
    }

    // Default to 'A' for all other products
    return 'A';
  });


  const FALLBACK_DISCOUNT_PERCENTAGE = 10;

  const resolveDefaultPurchaseType = (variantSupportsSubscription) => {
    const preferred =
      (preferences.defaultPurchaseType === 'subscription' ||
        preferences.defaultPurchaseType === 'one-time')
        ? preferences.defaultPurchaseType
        : undefined;
  
    if (paymentType === 'subscription') return 'subscription';
    if (paymentType === 'one-time') return 'one-time';
  
    if (preferred === 'subscription' && !variantSupportsSubscription) {
      return 'one-time';
    }
  
    if (preferred) return preferred;
  
    return getPaymentTypeFromURL();
  };

  const mapVariantName = (variantId) => {
    const nameMap = {
      '44308819214578': 'Pina Colada Seltzer 15g Ketohol 12x12oz (Stevia)',
      '47022116077810': 'Strawberry Spritz 15g Ketohol 12x12oz (Stevia)',
      '47081038086386': 'Ginger Mule 17g Ketohol 12x12oz (Stevia)',
      '47106967798002': 'Ginger Mule Concentrate 12x2oz 17g Ketohol (Stevia)',
      '46990745239794': 'Ketohol Concentrate 17g Ketohol 12x2oz  (Raw & Nasty)',
      '45243736064242': 'Dr(It)Up <small>(Phasing out)</small> 17g Ketohol 12x8oz (Raw & Nasty)'
    };

    return nameMap[variantId];
  };



  // Modify the variants useMemo to include the name mapping

  const variants = React.useMemo(() => {


    const exclusionPhrases = ['hidden', 'ketone shot x 6 bottles'];

    const visibleVariants = productAsItAs.variants?.filter(v => {
      const titleLower = v.title.toLowerCase();
      return !exclusionPhrases.some(phrase => titleLower.includes(phrase));
    });

    const currentProductId = productAsItAs.id?.toString();

    const targetUnclickableTitle = 'New: Ginger Mule (Stevia) 2oz Concentrate 12 pack';

    const unclickableVariantTitles = [
      //'New: Ginger Mule (Stevia) 2oz Concentrate 12 pack',
      'Ginger Mule (Stevia!) 12oz 12 pack' 
    ]; 

    const mappedVariants = visibleVariants?.map((v) => {
      const hasSubscriptionOption = v.selling_plan_allocations?.length > 0;
        const originalPrice = +v.price / 100;


      //const isThisVariantUnclickable = v.title === targetUnclickableTitle;
      //const isThisVariantUnclickable = unclickableVariantTitles.includes(v.title);
      const isThisVariantUnclickable = !v.available || unclickableVariantTitles.includes(v.title);





    /*  if (currentDiscountRule && String(v.id) === currentDiscountRule.variantId) {
        const discountedPrice = originalPrice * (1 - currentDiscountRule.percentage / 100);
        
        console.log(`Applying special ${currentDiscountRule.percentage}% discount to variant ${v.id}`); // Optional: for debugging

        return {
          ...v,
          title: v.title,
          originalPrice: originalPrice,
          price: discountedPrice, // One-time price is the special discounted price
          subscriptionPrice: discountedPrice, // Subscription price is ALSO the special discounted price
          discountPercentage: currentDiscountRule.percentage,
          hasSubscriptionOption,
          isUnclickable: isThisVariantUnclickable,
        };
      } */

      if (isFrankPromotion) {
        let ruleToApply = null;
        if (String(v.id) === specialDiscountRules.frank20.variantId) {
            ruleToApply = specialDiscountRules.frank20;
        } else if (String(v.id) === specialDiscountRules.frank33.variantId) {
            ruleToApply = specialDiscountRules.frank33;
        }

        if (ruleToApply) {
            const discountedPrice = originalPrice * (1 - ruleToApply.percentage / 100);
            return {
                ...v,
                title: v.title,
                originalPrice: originalPrice,
                price: discountedPrice, // Special discounted price for one-time
                subscriptionPrice: discountedPrice, // Same for subscription
                discountPercentage: ruleToApply.percentage,
                hasSubscriptionOption,
                isUnclickable: isThisVariantUnclickable,
            };
        }
      }

      const calculatedPrice = hasSubscriptionOption
      ? +v.selling_plan_allocations[0].price / 100
      : +v.price / 100 * (1 - FALLBACK_DISCOUNT_PERCENTAGE / 100);
      const calculatedDiscountPercentage = hasSubscriptionOption
      ? Math.round((1 - v.selling_plan_allocations[0].price / v.price) * 100)
      : FALLBACK_DISCOUNT_PERCENTAGE;


      return {
        ...v,
        title: v.title, 
        originalPrice: originalPrice,
        price: +v.price / 100,
        subscriptionPrice: calculatedPrice,
        discountPercentage: calculatedDiscountPercentage,
        hasSubscriptionOption,
        isUnclickable: isThisVariantUnclickable
      };
    });

    const sortByClickableThenCriteria = (a, b, criteriaSortFn) => {
      // Primary sort: Clickable items first
      if (a.isUnclickable && !b.isUnclickable) return 1;
      if (!a.isUnclickable && b.isUnclickable) return -1;
      // Secondary sort: Apply the specific criteria
      return criteriaSortFn(a, b);
  };

  

    if (currentProductId === '4901145608328') {
      //console.log("Applying KetoneAid Ke4 Sorting (Product ID: 4901145608328)"); // Optional debug log
      const orderMap = {
        'Ke4 w/ Stevia (3 x 60mL)': 1,
        'Ke4 w/ Stevia (12 x 60mL)': 2,
        'Ke4 w/ Stevia (36 x 60mL) BULK': 3,
        'Ke4 w/ Sucralose (3 x 50mL)': 4,
        'Ke4 w/ Sucralose (12 x 50mL)': 5,
        'Ke4 w/ Sucralose (36 x 50mL) BULK': 6
      };

     /* return mappedVariants?.sort((a, b) => {
        const orderA = orderMap[a.title];
        const orderB = orderMap[a.title];
        return (orderA || 999) - (orderB || 999);
      }); */
      return mappedVariants.sort((a, b) => sortByClickableThenCriteria(a, b, (critA, critB) => {
        const orderA = orderMap[critA.title];
        const orderB = orderMap[critB.title]; // Corrected: was critA.title
        return (orderA || 999) - (orderB || 999);
      }));
    } else if (currentProductId === '8159023497458') { // Use 'else if' here
      //console.log("Applying Ketone Shot Sorting (Product ID: 8159023497458)"); // Optional debug log
      const orderMap = {
        'Ketone Shot x 12 Bottles': 1,
        'Ketone Shot x 30 Bottles': 2,
        'Ketone Shot x 60 Bottles': 3
      };
     /* return mappedVariants?.sort((a, b) => {
        const orderA = orderMap[a.title];
        const orderB = orderMap[a.title];
        return (orderA || 999) - (orderB || 999);
      }); */
      return mappedVariants.sort((a, b) => sortByClickableThenCriteria(a, b, (critA, critB) => {
        const orderA = orderMap[critA.title];
        const orderB = orderMap[critB.title]; // Corrected: was critA.title
        return (orderA || 999) - (orderB || 999);
      }));
    }

    // Special sorting for test product with Pina Colada variant first (and A/B test sorting)
    if (currentProductId === '5299129155744') {
      // Apply name mapping here for the test product
      const mappedAndNamedVariants = mappedVariants?.map(v => ({
        ...v,
        title: mapVariantName(v.id)
      }));


      /* return mappedAndNamedVariants?.sort((a, b) => {
        // Always show Pina Colada variant first
        if (a.title.includes('Pina Colada Seltzer 15g Ketohol 12x12oz (Stevia)')) return -1;
        if (b.title.includes('Pina Colada Seltzer 15g Ketohol 12x12oz (Stevia)')) return 1;

        // For other variants, maintain A/B test sorting
        const priceA = a.price;
        const priceB = b.price;
        return abTestVariant === 'A' ?
          priceB - priceA :  // Highest first for A
          priceA - priceB;   // Lowest first for B
      }); */
      return mappedAndNamedVariants.sort((a, b) => sortByClickableThenCriteria(a, b, (critA, critB) => {
        // Pina Colada always first among its clickability group
       /*if (critA.id.includes('Pina Colada Seltzer 15g Ketohol 12x12oz (Stevia)')) return -1;
        if (critB.id.includes('Pina Colada Seltzer 15g Ketohol 12x12oz (Stevia)')) return 1;*/

        const pinaColadaVariantId = '47081038086386'; // Define the ID clearly

        // Check if critA is Pina Colada
        const isCritAPinaColada = String(critA.id) === pinaColadaVariantId;
        // Check if critB is Pina Colada
        const isCritBPinaColada = String(critB.id) === pinaColadaVariantId;
    
        if (isCritAPinaColada && !isCritBPinaColada) {
          return -1; // critA (Pina Colada) comes before critB
        }
        if (!isCritAPinaColada && isCritBPinaColada) {
          return 1;  // critB (Pina Colada) comes before critA
        }
        
        // Then A/B test price sorting
        const priceA = critA.price;
        const priceB = critB.price;
        return abTestVariant === 'A' ? priceB - priceA : priceA - priceB;
      }));
    }

    // Default sorting (price high to low) for all other products
    //return mappedVariants?.sort((a, b) => b.price - a.price);

    // Default sorting for all other products: Clickable first, then by price (high to low)
    return mappedVariants.sort((a, b) => sortByClickableThenCriteria(a, b, (critA, critB) => {
          return critB.price - critA.price; // Default: price high to low
      }));
  }, [productAsItAs.variants, abTestVariant]);


  const viewCart = () => {
    window.location.href = '/cart';
  };

  // Function to get the payment type from the URL
  const getPaymentTypeFromURL = () => {
    const path = window.location.pathname;
    if (path.includes('/start') || path.includes('/pay')) {
      return 'subscription';
    }
    // If no URL parameter, use variant to decide
    // Variant B should default to subscription
    if (abTestVariant === 'B') {
      return 'subscription';
    }

    // Default for variant A
    return 'one-time';
  };

  const getDefaultSelection = () => {
    const paymentType = getPaymentTypeFromURL();
    console.log('paymentType from URL:', paymentType);
    return paymentType;
    
  };



  /*const [formData, setFormData] = useState(() => {
    const initialState = {
      variant: variants[0],
      subType: variants[0]?.hasSubscriptionOption ? getDefaultSelection() : "one-time",
      quantity: 1,
    };
    console.log('Initial formData:', initialState);
    return initialState;
  });*/

  
  const initialVariant = variants.find(v => String(v.id) === urlParams?.variant) || variants[0];

  const [formData, setFormData] = useState(() => {
    //const initialVariant = variants[0];
    const initialSubType = resolveDefaultPurchaseType(
      initialVariant?.hasSubscriptionOption,
    );

    const safeInitialSubType =
      initialVariant?.hasSubscriptionOption || initialSubType !== 'subscription'
        ? initialSubType
        : 'one-time';

    const initialState = {
      variant: initialVariant,
      subType: safeInitialSubType,
      quantity: 1,
    };
    console.log('Initial formData:', initialState);
    return initialState;
  });



  useEffect(() => {
    if (!formData.variant?.hasSubscriptionOption && formData.subType === 'subscription') {
      setFormData(prev => ({
        ...prev,
        subType: 'one-time'
      }));
    }
  }, [formData.variant]);

  const [localCart, setLocalCart] = useState(null);


  //const [variant_to_use, setVariant_to_use] = useState(variants[0]?.id || null);
  const [variant_to_use, setVariant_to_use] = useState(initialVariant?.id || null);

  const [selling_plan_to_use, setSelling_plan_to_use] = useState(null);



  const handleVariantSelect = (variantId) => {
    
    const selectedVariant = variants.find(v => v.id === variantId);
    if (selectedVariant?.isUnclickable) {
      console.log("Selection prevented for unclickable variant:", selectedVariant.title);
      return; // Do nothing if it's the unclickable variant
    }

    // If it's clickable, proceed with state updates and other logic
    setVariant_to_use(variantId);

    // If switching to a variant without subscription, force one-time purchase
    if (!selectedVariant?.hasSubscriptionOption && formData.subType === 'subscription') {
      setFormData(prev => ({
        ...prev,
        subType: 'one-time'
      }));
    }
    updateProductImage(variantId);

    const newUtmSource = variantIdToUtmMap[variantId.toString()];

    // Only update the URL if the selected variant is part of the special promotion.
    if (newUtmSource) {
      // Use the URL API to easily manipulate search parameters.
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', variantId);
      currentUrl.searchParams.set('utm_source', newUtmSource);
  
      // Use replaceState to update the address bar without a page reload.
      // The first argument is a state object, the second is a title (unused), the third is the new URL.
      window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
    }


  };



  //grok version

  const updateShopifyPrice = (price) => {
    const targetSelector = '.price.price--large.recharge-inner-most-price';
    let priceElements = document.querySelectorAll(targetSelector);

    // If elements are found, update them immediately
    if (priceElements.length > 0) {
      priceElements.forEach(element => {
        const currentPrice = parseFloat(element.textContent.replace(/[^0-9.]/g, '')) || 0;
        const targetPrice = parseFloat(price) || 0;

        if (isNaN(targetPrice)) {
          console.error('Invalid target price:', price);
          element.innerHTML = `${currencySymbol}0.00`;
          return;
        }

        // Smooth animation
        const startTime = performance.now();
        const duration = 300; // milliseconds

        const animatePrice = (currentTime) => {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const easeOutCubic = 1 - Math.pow(1 - progress, 3);
          const displayPrice = currentPrice + (targetPrice - currentPrice) * easeOutCubic;

          element.innerHTML = `${currencySymbol}${displayPrice.toFixed(2)}`;

          if (progress < 1) {
            requestAnimationFrame(animatePrice);
          }
        };

        requestAnimationFrame(animatePrice);
      });
    } else {
      // If not found, observe the DOM for changes
      console.warn('Price element not found, setting up observer...');
      const observer = new MutationObserver((mutations, obs) => {
        priceElements = document.querySelectorAll(targetSelector);
        if (priceElements.length > 0) {
          priceElements.forEach(element => {
            element.innerHTML = `${currencySymbol}${price.toFixed(2)}`; // Initial set without animation
          });
          obs.disconnect();
          updateShopifyPrice(price); // Re-run with animation now that elements exist
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      // Clean up observer after 10 seconds if still not found
      setTimeout(() => observer.disconnect(), 10000);
    }
  };



  const handleQuantityChange = (change) => {
    setFormData(prev => ({
      ...prev,
      quantity: Math.max(1, prev.quantity + change)
    }));
  };

  const renderHTML = (htmlString) => {
    return <span dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [isBuyingNow, setIsBuyingNow] = useState(false);

  const addToCartWithAnimation = () => {
    setIsAddingToCart(true);
    addToCart();
    setTimeout(() => setIsAddingToCart(false), 1000); // Duration of the animation
  };

  const buyNowWithAnimation = () => {
    setIsBuyingNow(true);
    buyNow();
    setTimeout(() => setIsBuyingNow(false), 500);
  };



  const addToCart = () => {
    const selectedProduct = {
      id: variant_to_use,
      quantity: formData.quantity,
      price: formData.variant.price,
    };

    if (formData.subType === 'subscription') {
      selectedProduct.selling_plan = selling_plan_to_use;
    }
    const formdata = {
      items: [selectedProduct],

    };



    fetch(`https://${window.location.host}/cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formdata),
    })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        if (data.status && data.status === 422) {
          throw new Error(data.description || "Error adding product to cart");
        }

        // Dispatch cart:refresh event
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          /*detail: {
            cart: updatedCart,
            openMiniCart: window.themeVariables.settings.cartType === "drawer"
          }*/
        }));

        // Show cart notification
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: "success",
            error: ""
          }
        }));

        // Dispatch cart:updated event
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: localCart
          }
        }));

      })
      .catch((error) => {
        console.error("Error:", error);
        // Revert local cart update
        // Show error notification
        document.documentElement.dispatchEvent(new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: "error",
            error: error.message
          }
        }));
      });
    /*   return updatedCart; // Return the updated cart
     }); */
  };


  const buyNow = () => {
    const selectedProduct = {
      id: variant_to_use,
      quantity: formData.quantity,
    };

    if (formData.subType === 'subscription') {
      selectedProduct.selling_plan = selling_plan_to_use;
    }

    const formdata = {
      items: [selectedProduct],

    };

    fetch(`https://${window.location.host}/cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formdata),
    })
      .then(() => {
        window.location.replace(`https://${window.location.host}/checkout`);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const updateProductImage = (variantId) => {
    const selectedVariant = variants.find(v => v.id === variantId);
    if (selectedVariant) {
      const imageElement = document.querySelector('.product__media-image-wrapper img');
      if (imageElement) {
        let imageSrc = '';
        if (selectedVariant.featured_image && typeof selectedVariant.featured_image === 'string') {
          // This is for the page structure
          imageSrc = selectedVariant.featured_image;
        }
        else if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          // This is for the product structure
          imageSrc = selectedVariant.featured_image.src;
        }

        if (imageSrc) {
          imageElement.src = imageSrc;
          imageElement.srcset = generateSrcSet(imageSrc);
          imageElement.alt = selectedVariant.title || 'Product Image';
        }
      }
    }
  };

  const [textValues, setTextValues] = useState({
    subscription_first: true,
    subscription_selected: true,
    subscription_title: "AutoShip & Save 10%",
    subscription_text: "Easily pause, or cancel at any time",
    one_time_title: "Try Once",
    add_to_cart_button_color: "#47c112",
    buy_now_button_color: "#000000",
    border_color: "#e0e0e0",
    active_border_color: "#47c112",
    hover_color: "#f0fff0",
  });

  const generateSrcSet = (src) => {
    const widths = [400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800];
    return widths.map(width => `${src}${src.includes('?') ? '&' : '?'}width=${width} ${width}w`).join(', ');
  };


  const subscriptionSavings = useMemo(() => {
    const variant = formData.variant;
    if (!variant?.hasSubscriptionOption) return null;
    const basePerUnit = variant.price ?? 0;
    const subscriptionPerUnit = variant.subscriptionPrice ?? basePerUnit;
    const savings = (basePerUnit - subscriptionPerUnit) * formData.quantity;
    return savings > 0.009 ? savings : null;
  }, [formData.variant, formData.quantity]);




  const subscriptionHeadingHTML = useMemo(() => {
    const template =
      currentProductId === ke4ProductId
        ? locales?.subscriptionLocale?.KE4headingTitle
        : locales?.subscriptionLocale?.headingTitle;
    if (!subscriptionSavings) return template;

    const formattedSavings = `${currencySymbol}${subscriptionSavings.toFixed(2)}`;
    if (typeof template === "string" && template.includes("{{savings}}")) {
      return template.replace(/{{\s*savings\s*}}/gi, formattedSavings);
    }
    return `<strong>Auto-Ship & Save ${formattedSavings}</strong>`;
  }, [subscriptionSavings, currentProductId, ke4ProductId, locales, currencySymbol]);


  useEffect(() => {
    const selectedVariant = variants.find(v => v.id === variant_to_use);
    setFormData(prev => ({ ...prev, variant: selectedVariant }));


    if (selectedVariant) {
      const priceToUse = formData.subType === 'subscription'
        ? selectedVariant.subscriptionPrice
        : selectedVariant.price;
      const totalPrice = priceToUse * formData.quantity;
        console.log(`[${Date.now()}] (using refs) Calling updateShopifyPrice with price:`, totalPrice);
        updateShopifyPrice(totalPrice);
    }
  }, [formData.subType, variant_to_use, formData.quantity]);

  const displayPrice = useMemo(() => {
    const selectedVariant = variants.find(v => v.id === variant_to_use);
    if (!selectedVariant) return '0.00';
    const priceToUse = formData.subType === 'subscription' && selectedVariant.hasSubscriptionOption
      ? selectedVariant.subscriptionPrice
      : selectedVariant.price;
    return (priceToUse * formData.quantity).toFixed(2);
  }, [variant_to_use, formData.subType, formData.quantity, variants]);





  const priceInfo = useMemo(() => {
    const selectedVariant = formData.variant;
    if (!selectedVariant) {
        return { finalPrice: '0.00', originalPrice: null };
    }

    const priceToUse = formData.subType === 'subscription' && selectedVariant.hasSubscriptionOption
      ? selectedVariant.subscriptionPrice
      : selectedVariant.price;

    const finalPrice = priceToUse * formData.quantity;
    const originalDisplayPrice = (selectedVariant.originalPrice || selectedVariant.price) * formData.quantity;

    // Only show the original price if there's a meaningful discount
    const showOriginalPrice = originalDisplayPrice > finalPrice + 0.01;

    return {
      finalPrice: finalPrice.toFixed(2),
      originalPrice: showOriginalPrice ? originalDisplayPrice.toFixed(2) : null,
    };
  }, [formData.variant, formData.subType, formData.quantity]);





  const hasMultipleVariants = variants && variants.length > 1;


  const purchaseOrder =
  preferences.purchaseOrder === 'subscription-first'
    ? ['subscription', 'one-time']
    : ['one-time', 'subscription'];

const renderOneTimeCard = () => (

            <div id="one-time-option" className="chargezen_purchaseCard">
            <div className="chargezen_purchaseBtn chargezen_purchaseBtnOnetime chargezen_purchaseBtn--active">
              <div className="chargezen_purchaseBtnContent">
                <div
                  className="chargezen_purchaseBtnTop"
                  onClick={() => setFormData({ ...formData, subType: "one-time" })}
                >
                  <div className={`chargezen_purchaseBtnRadio ${formData?.subType === "one-time" ? "--selected" : ""}`} />
                  <div className="chargezen_purchaseBtnTextWrap">
                    <p className="chargezen_purchaseBtnTitle">
                      {locales?.oneTimeLocale?.headingTitle}
                      <span className="chargezen_purchaseBtnTitleShipping">
                        {locales?.oneTimeLocale?.headingSubTitle}
                      </span>
                    </p>
                    <p className="chargezen_purchaseBtnPrice">
                      <span>
                        {currencySymbol}{(formData?.variant?.price * formData.quantity).toFixed(2)}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
);



const renderSubscriptionCard = () => {
  if (!formData.variant?.hasSubscriptionOption) return null;
  return (
    <div id="subscription-option" className="chargezen_purchaseCard">
    <div className="chargezen_purchaseBtn chargezen_purchaseBtnSubscribe chargezen_purchaseBtn--active">
      <div className="chargezen_purchaseBtnContent">
        <div
          className="chargezen_purchaseBtnTop"
          onClick={() => setFormData({ ...formData, subType: "subscription" })}
        >
          <div className={`chargezen_purchaseBtnRadio ${formData?.subType === "subscription" ? "--selected" : ""}`} />
          <div className="chargezen_purchaseBtnTextWrap">
            <div className="chargezen_purchaseBtnContentLeft">
              {/*<p className="chargezen_purchaseBtnTitle">
                {renderHTML(locales?.subscriptionLocale?.headingTitle)}
              </p>
              <p className="chargezen_purchaseBtnSubtitle">
                {currentProductId === ke4ProductId
                  ? renderHTML(locales?.subscriptionLocale?.KE4headingTitle)
                  : renderHTML(locales?.subscriptionLocale?.headingTitle) }
              </p> */}
              <p className="chargezen_purchaseBtnTitle">
              {subscriptionHeadingHTML ? renderHTML(subscriptionHeadingHTML) : null}
            </p>
              <p className="chargezen_purchaseBtnSubtitle">
                {locales?.subscriptionLocale?.headingSubTitle}
              </p>
              {/*<ul className="chargezen_subscriptionBenefits">
              <li>Save 10% on every order – Exclusive autoship discount.</li>
              <li>Access to Perks – Get exclusive discounts, samples etc.</li>
              <li>Convenient auto-delivery – Ensure you never run out.</li>
              <li>Flexible schedule – Adjust deliveries to match your routine.</li>
            </ul> */}
            </div>
            <div className="chargezen_purchaseBtnContentRight">
              <p className="chargezen_purchaseBtnPrice">

                <span className="chargezen_discountedPrice">
                  {currencySymbol}{(formData?.variant?.subscriptionPrice * formData.quantity).toFixed(2)}
                </span>
                {formData?.variant?.discountPercentage > 0 && (
                  <span className="chargezen_discountPercentage">
                    {/* ({formData?.variant?.discountPercentage}% off) */}
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className={`chargezen_purchaseBtnBottom ${formData?.subType === "one-time" ? "hidden" : ""}`}>
          <Frequency
            setsfrequency={(id) => setSelling_plan_to_use(id)}
            variantId={variant_to_use}
          />
        </div>
      </div>
    </div>
  </div>
  );
};




  return (
    <>
      <InjectStyles color={textValues} />
      <div className="chargezen_buyBox">
        {/*<div className="chargezen_price_display">
          <span>{currencySymbol}{displayPrice}</span>
        </div> */}
        <div className="chargezen_price_display">
          <span className="chargezen_final_price">{currencySymbol}{priceInfo.finalPrice}</span>
          {priceInfo.originalPrice && (
            <span className="chargezen_original_price">
              {currencySymbol}{priceInfo.originalPrice}
            </span>
          )}
        </div>
        <div className="chargezen_giftsTypesWrapper">

          {hasMultipleVariants && (
          <div className="chargezen_variantSelection">
            {variants
              .slice() // 1. Create a copy to avoid changing the original sorted array
              .sort((a, b) => { // 2. Sort the copy
                if (urlParams?.variant) {
                  const urlVariantId = urlParams.variant;
                  if (String(a.id) === urlVariantId) return -1; // Move variant 'a' to the top
                  if (String(b.id) === urlVariantId) return 1;  // Move variant 'b' to the top
                }
                return 0; // Keep original order for all other items
              })
            .map((variant) => {
              const isComingSoon = variant.title.toLowerCase().includes('soon');
              const isDiscontinued = variant.title.toLowerCase().includes('(discontinued)');
              const isSoldOut = variant.title.toLowerCase().includes('sold out') || isComingSoon || isDiscontinued;
              const displayPrice = formData.subType === 'subscription' && variant.hasSubscriptionOption
                ? variant.subscriptionPrice
                : variant.price;
              const isUnclickable = variant.isUnclickable;

              return (
                <div
                  key={variant.id}
                  className={`chargezen_variantOption 
                  ${variant.id === variant_to_use ? 'selected' : ''} 
                  ${isSoldOut ? 'sold-out' : ''}
                  ${isUnclickable ? 'unclickable' : ''}`} 
                  onClick={() => handleVariantSelect(variant.id)} // No more condition here
                >
                  
                  <span className="chargezen_variantTitle" title={variant.title} dangerouslySetInnerHTML={{ __html: variant.title }}></span>
                  {/*<span className="chargezen_variantTitle" title={variant.title}>{variant.title}</span>*/}
                  <span className="chargezen_variantPrice">
                    {currencySymbol}{displayPrice.toFixed(2)}
                  </span>
                </div>
              );
            })}
          </div>
          )}

          {!isFrankPromotion && (
          <div className="chargezen_quantityContainer">
            <span className="chargezen_quantityLabel">Quantity</span>
            <div className="chargezen_quantitySelector">
              <button onClick={() => handleQuantityChange(-1)} className="chargezen_quantityButton">
                <Minus size={16} />
              </button>
              <span className="chargezen_quantityValue">{formData.quantity}</span>
              <button onClick={() => handleQuantityChange(1)} className="chargezen_quantityButton">
                <Plus size={16} />
              </button>
            </div>
          </div>
          )}

          {/*{hasMultipleVariants && (
          <div className="chargezen_variantTitleDisplay">
            {formData.variant?.title || 'Select a variant'}
          </div>
          )} */}

          {purchaseOrder.map((option) => {
            if (option === 'subscription') {
              return formData.variant?.hasSubscriptionOption
                ? renderSubscriptionCard()
                : null;
            }
            if (isFrankPromotion) return null;
            return renderOneTimeCard();
            //return renderOneTimeCard();
          })}


          {/*<div className="chargezen_atcWrap" style={{ marginBottom: '5px' }}>
            <button
              onClick={addToCartWithAnimation}
              className={`chargezen_atc ${isAddingToCart ? 'button-click' : ''}`}
              type="button"
              disabled={isAddingToCart}
            >
              {isAddingToCart ? 'ADDING...' : 'ADD TO CART'}
            </button>
          </div> */}

          <div className="chargezen_atcWrap" style={{ marginBottom: '5px' }}>
            <button
              onClick={isFrankPromotion ? buyNowWithAnimation : addToCartWithAnimation}
              className={`chargezen_atc ${isAddingToCart || isBuyingNow ? 'button-click' : ''}`}
              type="button"
              disabled={isAddingToCart || isBuyingNow}
            >
              {isAddingToCart ? 'ADDING...' : (isFrankPromotion ? 'Purchase' : 'ADD TO CART')}
            </button>
          </div>

          {!isFrankPromotion && (
          <div className="chargezen_atcWrapNow">
            <button
              onClick={viewCart}
              className={`chargezen_atc_now ${isBuyingNow ? 'button-click' : ''}`}
              type="button"
              disabled={isBuyingNow}
            >
              {isBuyingNow ? 'REDIRECTING...' : 'VIEW CART'}
            </button>
          </div>
          )}

        </div>
      </div>
    </>
  );
};